import { atom, useAtom, useAtomValue } from "jotai";

import { marketAtom } from "../../app/portfolio/market";

export const perpUnitsAtom = atom((get) => {
  const market = get(marketAtom);
  return [market.underlying, "USD"];
});

const _perpUnitAtom = atom<string>("");

export const perpUnitAtom = atom(
  (get) => {
    const market = get(marketAtom);
    const perpUnits = get(perpUnitsAtom);
    const perpUnit = get(_perpUnitAtom);

    // Initialize with first value if not set
    if (!perpUnit && perpUnits.length > 0) {
      return perpUnits[0];
    }

    // Validate current selection is still valid
    if (
      Boolean(perpUnit) &&
      perpUnit !== market.underlying &&
      perpUnit !== "USD"
    ) {
      return market.underlying;
    }

    return perpUnit;
  },
  (get, set, newValue: string) => {
    set(_perpUnitAtom, newValue);
  },
);

export const isUnderlyingSelectedAtom = atom((get) => {
  const market = get(marketAtom);
  const perpUnit = get(perpUnitAtom);
  return perpUnit === market.underlying;
});

export const usePerpUnit = () => {
  const perpUnits = useAtomValue(perpUnitsAtom);
  const [perpUnit, setPerpUnit] = useAtom(perpUnitAtom);
  const isUnderlyingSelected = useAtomValue(isUnderlyingSelectedAtom);

  return {
    perpUnit,
    perpUnits,
    isUnderlyingSelected,
    setPerpUnit,
  };
};
